import { render, staticRenderFns } from "./reporte-comparativo.component.html?vue&type=template&id=942348d2&scoped=true&"
import script from "./reporte-comparativo.component.ts?vue&type=script&lang=ts&"
export * from "./reporte-comparativo.component.ts?vue&type=script&lang=ts&"
import style0 from "./reporte-comparativo.component.scss?vue&type=style&index=0&id=942348d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942348d2",
  null
  
)

export default component.exports